<ng-container *transloco="let t">
  <div class="w-full">
    <ui-layout-full-sider
      [isCollapsed]="isCollapsed()"
      (onToggle)="toggleCollapsed()"
    >
      <!-- Sider Slots -->
      <div sider-header class="py-3 px-2">
        <!-- <app-logo [isCollapsed]="isCollapsed()" /> -->
        <app-nav-menu-header [apps]="apps" [isOpen]="isCollapsed()" [env]="env"/>
      </div>
      <ui-menu
        sider-menu
        [items]="menuItems()"
        [isCollapsed]="isCollapsed()"
      ></ui-menu>
      <div sider-bottom>
        <ui-menu
          sider-menu
          [items]="menuBottomItems()"
          [isCollapsed]="isCollapsed()"
          [mode]="'vertical'"
          (onAction)="handleAction($event)"
        />
      </div>

      <!-- Main Layout Slots -->
      <div header class="w-full">
        <app-header />
      </div>
      <!-- Content Slot -->
      <div content>
        <ng-content></ng-content>
      </div>
    </ui-layout-full-sider>
  </div>
</ng-container>
